/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Bank_NameInputs */

const vi_invoice_bank_name = /** @type {(inputs: Invoice_Bank_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên ngân hàng`)
};

/**

* @param {Invoice_Bank_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_bank_name = /** @type {((inputs?: Invoice_Bank_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Bank_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_bank_name(inputs)
});